import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@maui/elements'

export const DrawerHeader = ({ onClose, children, ...props }) => {
  return (
    <Box
      display='flex'
      alignItems='center'
      backgroundColor='colorBackgroundOverlay'
      gridGap='8px'
      paddingX='spacePaddingXLarge'
      paddingY='spacePaddingMedium'
      {...props}
    >
      {children}
    </Box>
  )
}

DrawerHeader.displayName = 'DrawerHeader'

DrawerHeader.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
}
